import React from 'react';
import { Dismiss20Regular } from '@fluentui/react-icons';
import styles from './css/index.module.css';

function MetaRow({ label, value }) {
    if (value == null || value === '') return null;
    return (
        <>
            <dt>{label}</dt>
            <dd>{value}</dd>
        </>
    );
}

function assessmentClass(assessment) {
    const a = String(assessment || '').toUpperCase();
    if (a === 'RED') return styles.aiWardenObsAssessmentRed;
    if (a === 'AMBER') return styles.aiWardenObsAssessmentAmber;
    if (a === 'GREEN') return styles.aiWardenObsAssessmentGreen;
    return '';
}

/**
 * Read-only saved-observation citation rail (AiWarden). Mirrors IRL citation sidebar.
 */
const ObservationCitationSidebar = ({ detail, onClose }) => {
    if (!detail) return null;

    const title = detail.observation_ref || (detail.observation_id != null ? `OBS-${detail.observation_id}` : 'Saved observation');
    const bodyText = detail.observation_text || detail.excerpt;

    return (
        <div className={styles.aiWardenIrlSidebar}>
            <div className={styles.aiWardenPdfHeader}>
                <div className={styles.aiWardenPdfTitleWrap}>
                    <span className={styles.aiWardenKicker}>Observation citation</span>
                    <span className={styles.aiWardenPdfTitle} title={title}>
                        {title}
                    </span>
                </div>
                <button type="button" className={styles.aiWardenPdfClose} onClick={onClose} aria-label="Close observation citation panel">
                    <Dismiss20Regular />
                </button>
            </div>
            <div className={styles.aiWardenIrlSidebarBody}>
                <dl className={styles.aiWardenIrlMeta}>
                    <MetaRow label="Workstream" value={detail.workstream_repr} />
                    <MetaRow label="Tag" value={detail.tag_repr} />

                    {detail.assessment && (
                        <>
                            <dt>Assessment</dt>
                            <dd>
                                <span className={assessmentClass(detail.assessment)}>{detail.assessment}</span>
                            </dd>
                        </>
                    )}
                    <MetaRow label="SWOT" value={detail.swot_label || detail.swot} />
                    <MetaRow label="Impact" value={detail.impact} />
                </dl>

                {bodyText && (
                    <section className={styles.aiWardenIrlSection}>
                        <h3 className={styles.aiWardenInsightsHeadline}>Observation</h3>
                        <p className={styles.aiWardenIrlText}>{bodyText}</p>
                    </section>
                )}

                {detail.comments && (
                    <section className={styles.aiWardenIrlSection}>
                        <h3 className={styles.aiWardenInsightsHeadline}>Comments</h3>
                        <p className={styles.aiWardenIrlTextMuted}>{detail.comments}</p>
                    </section>
                )}

                {!bodyText && !detail.comments && <p className={styles.aiWardenInsightsMuted}>No observation text was included in this citation payload.</p>}
            </div>
        </div>
    );
};

export default ObservationCitationSidebar;
